import { render, staticRenderFns } from "./DashboardEmbedSidebar.vue?vue&type=template&id=6bb15705&scoped=true&"
import script from "./DashboardEmbedSidebar.vue?vue&type=script&lang=js&"
export * from "./DashboardEmbedSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEmbedSidebar.vue?vue&type=style&index=0&id=6bb15705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb15705",
  null
  
)

export default component.exports